/** @file Animation-local time of a track entry: clock x timeScale, wrapped when looping, else clamped. */
import type { TrackEntry } from '../contracts/state';
import type { SkeletonData } from '../skeletonData';
import { loopPass } from '../state/loopPass';

/**
 * max(0, time) x timeScale, wrapped into its loop pass when looping (loopPass, the boundary rule stepState fires
 * complete on, so a completed pass samples the next one from 0), clamped to the duration otherwise; 0 for an empty
 * or unknown animation.
 */
export function animTime(data: SkeletonData, entry: TrackEntry): number {
  const duration = data.animations[entry.anim]?.duration ?? 0;
  if (duration <= 0) return 0;
  const t = Math.max(0, entry.time) * entry.timeScale;
  return entry.loop ? Math.max(0, t - duration * loopPass(t, duration)) : Math.min(t, duration);
}
